import { SubstrateConsumerTenantId } from '../models/Constants';
export function getBaseRequestData(context, identity, config) {
    return {
        aadAppId: context.aadAppId,
        correlationId: context.correlationId,
        edgeworthApiRootPath: config.edgeworthApiRootPath,
        getAccessToken: context.getAccessToken,
        iceApplicationId: config.iceApplicationId,
        jwtAuthEnabled: context.jwtAuthEnabled,
        officeHomeApiRoot: context.officeHomeApiRoot,
        objectId: identity.isMsa ? identity.puid : identity.objectId,
        substrateApiEndpoint: config.substrateApiEndpoint,
        tenantId: identity.isMsa
            ? SubstrateConsumerTenantId
            : identity.tenantId,
        currentPage: context.router.getCurrentPageForLogging(),
    };
}
//# sourceMappingURL=getBaseRequestData.js.map